import { render, staticRenderFns } from "./StackedBarChart.vue?vue&type=template&id=4ca8b215&scoped=true"
import script from "./StackedBarChart.vue?vue&type=script&lang=ts"
export * from "./StackedBarChart.vue?vue&type=script&lang=ts"
import style0 from "./StackedBarChart.vue?vue&type=style&index=0&id=4ca8b215&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca8b215",
  null
  
)

export default component.exports